import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { Globe } from "lucide-react";

export const Header = ({ showAdminLink = true, right = null }) => {
  const { lang, setLang, t } = useLang();
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-24 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center group" data-testid="header-logo">
          <img src="/step-logo-tight.png" alt="STEP - Syndicat des travailleuses et travailleurs étudiants et postdoctoraux de l'Université Laval" className="h-14 sm:h-[4.75rem] w-auto" />
        </Link>

        <div className="flex items-center gap-2 sm:gap-3">
          {right}
          {showAdminLink && (
            <Link
              to="/admin"
              data-testid="nav-admin-link"
              className="hidden sm:inline-flex text-sm font-medium text-slate-600 hover:text-primary transition-colors px-3 py-2"
            >
              {t("nav.admin")}
            </Link>
          )}
          <div className="flex items-center rounded-full border border-slate-200 bg-slate-50 p-0.5" data-testid="lang-switch">
            <Globe className="w-3.5 h-3.5 text-slate-400 ml-2 mr-1" />
            {["fr", "en"].map((l) => (
              <button
                key={l}
                data-testid={`lang-${l}`}
                onClick={() => setLang(l)}
                className={`px-2.5 py-1 text-xs font-semibold rounded-full transition-colors ${
                  lang === l ? "bg-primary text-white" : "text-slate-500 hover:text-slate-800"
                }`}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};
